<template>
  <div class="news-item__additional-info">
    <div class="news-item__category-or-tag">
      <a-tag v-if="isTagShown" :tag="tag" />
      <a-category v-else v-bind="category" :custom-name="categoryCustomName" />
    </div>

    <a-visibility v-if="sticker" hide :to="$breakpoint.desktopSm">
      <a-sticker :sticker="sticker" />
    </a-visibility>

    <a-icon
      v-if="isPinned"
      class="news-item__pin"
      :icon="ICON.PIN"
      :width="iconDimension"
      :height="iconDimension"
      :color="ICON_COLOR.BLUE"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ACategory from 'shared/ACategory'
import ATag from 'shared/ATag'
import AIcon, { ICON, ICON_COLOR } from 'shared/AIcon'
import ASticker from 'shared/ASticker'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

const THOUGHT_LEADERSHIP_TITLE = 'Thought Leaders'

export default {
  name: 'AdditionalInfo',
  mixins: [hydrationHelpers],
  components: { ACategory, AIcon, ASticker, ATag },
  props: {
    category: propValidator([PROP_TYPES.OBJECT]),
    tag: propValidator([PROP_TYPES.OBJECT]),
    sticker: propValidator([PROP_TYPES.OBJECT], false),
    isPinned: propValidator([PROP_TYPES.BOOLEAN], false, false),
    showTag: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  data() {
    return { ICON, ICON_COLOR }
  },
  computed: {
    ...mapGetters({
      checkIfThoughtLeadershipSlug: 'categories/checkIfThoughtLeadershipSlug'
    }),
    iconDimension() {
      return this.$_hydrationHelpers_mobileOrDesktopValue(25, 35)
    },
    isThoughtLeadershipCategory() {
      return this.checkIfThoughtLeadershipSlug(this.category.categorySlug)
    },
    categoryCustomName() {
      return this.isThoughtLeadershipCategory ? THOUGHT_LEADERSHIP_TITLE : null
    },
    isTagShown() {
      return !this.isThoughtLeadershipCategory && this.showTag
    }
  }
}
</script>

<style lang="scss" scoped>
.news-item {
  &__additional-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include desktop-sm {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 25px;
      margin-top: 6px;
    }
  }

  &__category-or-tag {
    margin: 5px 0;
    padding-right: 5px;

    @include mobile {
      margin: 0;
      padding-right: 0;
    }
  }

  &__pin {
    @include mobile {
      margin: 0;
    }
  }
}
</style>
